<div class="page-container">
    <div fxLayout="column">
        <app-page-header [section]="'Atoku'" [title]="'Storage & Equipment'"
            [description]="'Manage your Atoku storage and equipment here.'"></app-page-header>

        <div class="page-padding page-content full-screen-height-page-default" fxLayout="column">
            <div class="atoku-filter-bar" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                <mat-form-field class="custom-text-field atoku-search-field" appearance="outline" floatLabel="always">
                    <mat-label>Search</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Search by name..." #input>
                    <mat-icon matSuffix color="primary">search</mat-icon>
                </mat-form-field>

                <mat-button-toggle-group [value]="currentView" (change)="toggleView($event.value)">
                    <mat-button-toggle value="equipment">Equipment</mat-button-toggle>
                    <mat-button-toggle value="storage">Storage</mat-button-toggle>
                </mat-button-toggle-group>
            </div>

            <div class="table-card mat-elevation-z3" fxLayout="column">
                <div class="atoku-card-header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="16px">
                    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="12px">
                        <div class="atoku-card-actions">
                            <button class="button-action" mat-flat-button type="button" (click)="openAddDialog()">
                                <mat-icon>add</mat-icon>
                                <div class="button-text">Create {{ currentView === 'equipment' ? 'Equipment' : 'Storage' }}</div>
                            </button>

                            <button class="button-action" mat-flat-button type="button" *ngIf="hasSingleSelection"
                                (click)="editSelectedItem()">
                                <mat-icon>edit</mat-icon>
                                <div class="button-text">Edit</div>
                            </button>

                            <button class="button-action" mat-flat-button type="button" *ngIf="hasSelection"
                                (click)="removeSelectedItems()">
                                <mat-icon>delete</mat-icon>
                                <div class="button-text">Remove</div>
                            </button>
                        </div>
                    </div>
                </div>

                <table mat-table class="custom-table" [dataSource]="dataSource">
                    <ng-container matColumnDef="table-label">
                        <th mat-header-cell class="custom-table-label" *matHeaderCellDef
                            [attr.colspan]="displayedColumns.length"> {{ currentView === 'equipment' ? 'Equipment' :
                            'Storage' }} </th>
                    </ng-container>

                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let row">
                            <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                                (change)="toggleRow(row)" [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> {{ currentView === 'equipment' ? 'Equipment Name' :
                            'Storage Unit' }} </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.equipmentName}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef> Total Amount </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.totalAmount}} </td>
                    </ng-container>

                    <ng-container matColumnDef="bookedLast30Days">
                        <th mat-header-cell *matHeaderCellDef> Total Booked (Past 30 Days) </th>
                        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{element.bookedLast30Days}}
                        </td>
                    </ng-container>

                    <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
                    <tr mat-header-row class="custom-table-header" *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row class="custom-table-row" *matRowDef="let row; columns: displayedColumns;"
                        (click)="toggleRow(row)" [class.atoku-selected-row]="selection.isSelected(row)"></tr>
                </table>
                <mat-paginator #paginator class="custom-paginator" [pageSize]="10"
                    [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
            </div>
        </div>
    </div>
</div>
